import React from 'react'
import PropTypes from 'prop-types'

export const WrappedComponent = ({ component: Component, body: Body, ...props }) => {
  return <div><Component body={Body} {...props} /></div>
}

WrappedComponent.propTypes = {
  component: PropTypes.any,
  body: PropTypes.any
}

export default WrappedComponent



// WEBPACK FOOTER //
// ./src/components/WrappedComponent.js